import { render, staticRenderFns } from "./bdproduct2.vue?vue&type=template&id=6820c9e9&scoped=true"
import script from "./bdproduct2.vue?vue&type=script&lang=js"
export * from "./bdproduct2.vue?vue&type=script&lang=js"
import style0 from "./bdproduct2.vue?vue&type=style&index=0&id=6820c9e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6820c9e9",
  null
  
)

export default component.exports